/* tslint:disable */
/* eslint-disable */
/**
 * IRM.Web.Customer.API
 * 6d75acac-ec29-43a4-9fe0-2808f10c310c Development
 *
 * The version of the OpenAPI document: 2024.05.17.1151
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration";
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from "axios";
import globalAxios from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "../common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "../base";
// @ts-ignore
import { ItemModelODataResultCollection } from "../models";
/**
 * ItemApi - axios parameter creator
 * @export
 */
export const ItemApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiItemGet: async (
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Item`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Gets the list by card code.
     * @param {string} cardCode The card code.
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiItemGetListByCardCodeGet: async (
      cardCode: string,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'cardCode' is not null or undefined
      assertParamExists("apiItemGetListByCardCodeGet", "cardCode", cardCode);
      const localVarPath = `/api/Item/GetListByCardCode`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (cardCode !== undefined) {
        localVarQueryParameter["cardCode"] = cardCode;
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ItemApi - functional programming interface
 * @export
 */
export const ItemApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ItemApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiItemGet(
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ItemModelODataResultCollection>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiItemGet(
        $top,
        $skip,
        $filter,
        $orderby,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Gets the list by card code.
     * @param {string} cardCode The card code.
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiItemGetListByCardCodeGet(
      cardCode: string,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ItemModelODataResultCollection>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiItemGetListByCardCodeGet(
          cardCode,
          $top,
          $skip,
          $filter,
          $orderby,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * ItemApi - factory interface
 * @export
 */
export const ItemApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ItemApiFp(configuration);
  return {
    /**
     *
     * @param {ItemApiApiItemGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiItemGet(
      requestParameters: ItemApiApiItemGetRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<ItemModelODataResultCollection> {
      return localVarFp
        .apiItemGet(
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Gets the list by card code.
     * @param {ItemApiApiItemGetListByCardCodeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiItemGetListByCardCodeGet(
      requestParameters: ItemApiApiItemGetListByCardCodeGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<ItemModelODataResultCollection> {
      return localVarFp
        .apiItemGetListByCardCodeGet(
          requestParameters.cardCode,
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for apiItemGet operation in ItemApi.
 * @export
 * @interface ItemApiApiItemGetRequest
 */
export interface ItemApiApiItemGetRequest {
  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof ItemApiApiItemGet
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof ItemApiApiItemGet
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof ItemApiApiItemGet
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof ItemApiApiItemGet
   */
  readonly $orderby?: string;
}

/**
 * Request parameters for apiItemGetListByCardCodeGet operation in ItemApi.
 * @export
 * @interface ItemApiApiItemGetListByCardCodeGetRequest
 */
export interface ItemApiApiItemGetListByCardCodeGetRequest {
  /**
   * The card code.
   * @type {string}
   * @memberof ItemApiApiItemGetListByCardCodeGet
   */
  readonly cardCode: string;

  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof ItemApiApiItemGetListByCardCodeGet
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof ItemApiApiItemGetListByCardCodeGet
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof ItemApiApiItemGetListByCardCodeGet
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof ItemApiApiItemGetListByCardCodeGet
   */
  readonly $orderby?: string;
}

/**
 * ItemApi - object-oriented interface
 * @export
 * @class ItemApi
 * @extends {BaseAPI}
 */
export class ItemApi extends BaseAPI {
  /**
   *
   * @param {ItemApiApiItemGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ItemApi
   */
  public apiItemGet(
    requestParameters: ItemApiApiItemGetRequest = {},
    options?: AxiosRequestConfig
  ) {
    return ItemApiFp(this.configuration)
      .apiItemGet(
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Gets the list by card code.
   * @param {ItemApiApiItemGetListByCardCodeGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ItemApi
   */
  public apiItemGetListByCardCodeGet(
    requestParameters: ItemApiApiItemGetListByCardCodeGetRequest,
    options?: AxiosRequestConfig
  ) {
    return ItemApiFp(this.configuration)
      .apiItemGetListByCardCodeGet(
        requestParameters.cardCode,
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
